<div class="prompt-renderer-wrapper">
  @if (showHeaderAndInstructions) {
    @if (promptComponentInput.header && promptComponentInput!.header.length > 0) {
      <div class="header-wrapper test">
        <h4>{{ promptComponentInput.header }}</h4>
      </div>
    }

    @if (promptComponentInput.instructions && promptComponentInput!.instructions.length > 0) {
      <div class="instruction-wrapper">
        <h5>{{ promptComponentInput.instructions }}</h5>
      </div>
    }
  }

  <div class="prompt-renderer"
       id="pc-{{ promptComponentInput.componentType }}-input"
       [class.edit-text-input-view]="promptComponentInput.componentType === ComponentType.SingleFormField ||
           promptComponentInput.componentType === ComponentType.HorizontalFormField ||
           promptComponentInput.componentType === ComponentType.VerticalFormField"
       [class.mdc-editmode]="editFormFieldInput">
    <ng-container #inputContainer></ng-container>
  </div>
</div>
